<template>
    <az-container>
        <az-form>
            <menu-tabs-todas-homologacao/>

            <v-data-table :headers="colunas" :items="itens"
                          :total-items="(itens ? itens : []).length"
                          :pagination.sync="pagination" :loading="false" :style="cssVar"
                          no-data-text="Não há compras diretas em homologação" hide-actions
                          class="az-table-list table-todas-compras">
                <template slot="items" slot-scope="props">
                    <tr @click.stop.prevent="$emit('acessar', props.item)">
                        <td>
                            {{ props.item.dataHoraEncerramento | az-date(humanizarFormatoData(props.item.dataHoraEncerramento)) }}<br>
                            <span v-if="props.item.dataHoraEncerramento">
                                {{ props.item.dataHoraEncerramento | az-date(humanizarFormatoHora(props.item.dataHoraEncerramento)) }}
                            </span>
                        </td>
                        <td>
                            {{ props.item.processo }}
                            <br>
                            <span v-if="props.item.quantidadeRepeticoes">
                               <strong> Repetição: {{props.item.quantidadeRepeticoes}} </strong>
                            </span>
                        </td>
                        <td>
                            <expansao-texto :tamanho="125" :texto="props.item.objeto"/>
                        </td>
                        <td>
                            {{ props.item.tipo | cdEnum(tiposCompraDireta)}}
                        </td>
                        <td>
                            {{ props.item.orgao }}
                        </td>
                        <td class="table-actions" >
                            <v-tooltip top>
                                <a slot="activator" id="aAcessar">
                                    <i class="fas fa-sign-in-alt pr-2" aria-hidden="true" @click.stop="$emit('acessar', props.item)"/>
                                </a>
                                Acessar
                            </v-tooltip>
                            <v-tooltip top v-if="props.item.sequencialCompraPublica">
                                <a id="aAcessarPncp" @click.stop="$emit('acessarPncp', props.item)" slot="activator">
                                    <i class="fas fa-external-link-alt pr-2" aria-hidden="true"/>
                                    <span class="acao-mobile">Acessar no PNCP</span>
                                </a>
                                Acessar no PNCP
                            </v-tooltip>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </az-form>
    </az-container>
</template>

<script>
import {situacoesCompraDireta, tiposCompraDireta} from '@/core/constants'
import MenuTabsTodasHomologacao from '@/views/pages/comprador/components/MenuTabsTodasHomologacao'

export default {
    name: 'CompraDiretaEmHomologacaoTabela',
    components: {MenuTabsTodasHomologacao},
    props: {
        itens: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            situacoesCompraDireta,
            colunas: [
                {
                    text: 'Encerramento',
                    value: 'dataHoraEncerramento',
                    sortable: true,
                    align: 'left',
                    width: '40px',
                    class: 'primary--text'
                },
                {
                    text: 'Nº Processo',
                    value: 'processo',
                    sortable: true,
                    align: 'left',
                    width: '100px',
                    class: 'primary--text'
                },
                {
                    text: 'Objeto',
                    value: 'objeto',
                    sortable: true,
                    align: 'left',
                    width: '200px',
                    class: 'primary--text'
                },
                {
                    text: 'Tipo',
                    value: 'tipo',
                    sortable: true,
                    align: 'left',
                    width: '80px',
                    class: 'primary--text'
                },
                {
                    text: this.$t('main.comprador_todas_compras_diretas_orgao.text'),
                    value: 'orgao',
                    sortable: false,
                    align: 'left',
                    width: '40px',
                    class: 'primary--text'
                },
                {
                    text: 'Ações',
                    sortable: false,
                    align: 'center',
                    width: '30px',
                    class: 'primary--text'
                }
            ],
            pagination: {
                rowsPerPage: [10]
            },
            tiposCompraDireta
        }
    },
    computed: {
        cssVar() {
            const labelOrgao = this.$t('main.comprador_todas_compras_diretas_orgao.text')
            return {
                '--label-orgao': `"${labelOrgao}:"`
            }
        }
    },
}
</script>

<style scoped lang="stylus">
    .icon-alert-pncp
        color #ffb703

    .az-container
        margin-bottom 60px

    .table-todas-compras
        .acao-mobile
            display none

        td:hover
            cursor pointer !important

    @media (max-width 720px)
        .table-todas-compras
            td:nth-of-type(1):before
                content "Encerramento:"

            td:nth-of-type(2):before
                content "Nº Processo:"

            td:nth-of-type(3):before
                content "Objeto:"

            td:nth-of-type(4):before
                content "Tipo:"

            td:nth-of-type(5):before
                content var(--label-orgao)

            td:nth-of-type(6):before
                content "Situação:"

            td:nth-of-type(7):before, td:nth-of-type(1) br
                display none

            .acao-mobile
                display inline-block
                margin-left 3px

    @media (max-width 500px)
        .az-container
            margin 0
</style>
